import React from "react";
import { CheckCircle2, AlertCircle } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";

export const FailedEmailsTable = ({ failedEmails, onResolve }) => {
  if (!failedEmails.length) return null;
  return (
    <Card className="border-0 shadow-lg border-red-200" data-testid="failed-emails-table">
      <CardHeader className="bg-red-50">
        <CardTitle className="text-red-800 flex items-center gap-2">
          <AlertCircle className="h-5 w-5" /> Manual Intervention Required ({failedEmails.length})
        </CardTitle>
        <CardDescription className="text-red-600">These emails failed to parse automatically and need manual review</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-red-100">
              <tr>
                <th className="text-left p-4 font-semibold text-red-800">Subject</th>
                <th className="text-left p-4 font-semibold text-red-800">Sender</th>
                <th className="text-left p-4 font-semibold text-red-800">Date</th>
                <th className="text-left p-4 font-semibold text-red-800">Error</th>
                <th className="text-left p-4 font-semibold text-red-800">Actions</th>
              </tr>
            </thead>
            <tbody>
              {failedEmails.map((email, idx) => (
                <tr key={email.id} className={`border-b hover:bg-red-25 ${idx % 2 === 0 ? 'bg-white' : 'bg-red-25'}`}>
                  <td className="p-4 font-medium text-gray-900">{email.email_subject}</td>
                  <td className="p-4 text-gray-600">{email.email_sender}</td>
                  <td className="p-4 text-gray-600">{new Date(email.email_date).toLocaleDateString()}</td>
                  <td className="p-4 text-red-600 text-xs">{email.error_message}</td>
                  <td className="p-4">
                    <Button size="sm" variant="outline" onClick={() => onResolve(email.id)} className="text-green-600 hover:text-green-700 hover:bg-green-50" data-testid={`resolve-email-${email.id}`}>
                      <CheckCircle2 className="h-3 w-3 mr-1" /> Resolve
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
